/* ────────────────────────────────────────────────────────────
   Nombres de día/mes en español, para los mockups animados (Hero,
   demo de Agenda en Features) que muestran "hoy" — así la fecha se
   calcula con el reloj real de quien visita en vez de quedar fija
   y verse desactualizada con el tiempo. La hora (9:41) NO usa esto
   a propósito: es la convención de Apple en capturas de producto,
   no un dato que deba estar "en vivo".
   ──────────────────────────────────────────────────────────── */

export const WEEKDAY_ABBR_ES = ['DOM', 'LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB'];
export const WEEKDAY_FULL_ES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
export const MONTH_FULL_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** Día de la semana (abreviado) + número, para columnas de calendario. `offsetFromToday` en días. */
export const getDayLabel = (offsetFromToday: number) => {
  const d = new Date();
  d.setDate(d.getDate() + offsetFromToday);
  return { dow: WEEKDAY_ABBR_ES[d.getDay()], n: d.getDate() };
};
